// Limit okumasi common.func.js'e tasinmaz: o dosya router ve vue-i18n import ettiginden
// bagimsiz ureticilerden (faExport.js, LayoutXlsxExportService.js) cagrilinca cycle olusur.
import constant from "@/main.constants";
import permissionList from "@/jsons/permissionList";

function resolveCryptoOperation(operation) {
  if (typeof operation.then === "function") {
    return operation;
  }
  return new Promise((resolve, reject) => {
    operation.oncomplete = (event) => resolve(event.target.result);
    operation.onerror = reject;
  });
}

function base64ToBytes(value) {
  const binary = atob(value);
  return Uint8Array.from(binary, (char) => char.charCodeAt(0));
}

function hexToBytes(value) {
  return Uint8Array.from(value.match(/.{1,2}/g), (hex) => parseInt(hex, 16));
}

async function decryptExcelRowLimit(encryptedValue) {
  if (!encryptedValue) {
    return "";
  }
  try {
    const cryptoApi = window.crypto || window.msCrypto;
    const subtle = cryptoApi && (cryptoApi.subtle || cryptoApi.webkitSubtle);
    if (!subtle) {
      return "";
    }
    const keyBytes = Uint8Array.from(
      constant.EXCEL_ROW_LIMIT_ENCRYPTION_KEY,
      (char) => char.charCodeAt(0)
    );
    const cryptoKey = await resolveCryptoOperation(
      subtle.importKey("raw", keyBytes, { name: "AES-CBC" }, false, [
        "decrypt"
      ])
    );
    const decrypted = await resolveCryptoOperation(
      subtle.decrypt(
        {
          name: "AES-CBC",
          iv: hexToBytes(constant.EXCEL_ROW_LIMIT_ZERO_IV)
        },
        cryptoKey,
        base64ToBytes(encryptedValue)
      )
    );
    const bytes = new Uint8Array(decrypted);
    return typeof TextDecoder !== "undefined"
      ? new TextDecoder().decode(bytes)
      : String.fromCharCode.apply(null, bytes);
  } catch (error) {
    console.error("ExcelDownloadRowLimit cozulemedi:", error);
    return "";
  }
}

function hasUnlimitedExportPermission() {
  if (!localStorage.perms) {
    return false;
  }
  return (
    localStorage.perms.split(";").indexOf(permissionList.unlimitedExcelExport) >
    -1
  );
}

// 0 = limit yok. Yetki, eksik ayar ve gecersiz deger bu degeri dondurur.
export async function getExcelRowLimit() {
  if (hasUnlimitedExportPermission()) {
    return 0;
  }
  let clientSettings = {};
  try {
    clientSettings = localStorage.clientSettings
      ? JSON.parse(localStorage.clientSettings)
      : {};
  } catch (error) {
    console.error("clientSettings okunamadi:", error);
    return 0;
  }
  const limit = Number(
    await decryptExcelRowLimit(clientSettings.ExcelDownloadRowLimit)
  );
  if (!Number.isFinite(limit) || limit <= 0) {
    return 0;
  }
  return Math.min(Math.floor(limit), constant.MAX_EXCEL_SHEET_ROW_COUNT);
}

export async function limitRows(rows) {
  if (!Array.isArray(rows)) {
    return rows;
  }
  const limit = await getExcelRowLimit();
  if (limit === 0 || rows.length <= limit) {
    return rows;
  }
  return rows.slice(0, limit);
}

const excelRowLimitHelper = {
  getExcelRowLimit,
  limitRows
};

export default excelRowLimitHelper;
